import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'googleSheets',
  version: '4.5.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
